import { render, staticRenderFns } from "./view-dispute.vue?vue&type=template&id=d9e55fe4&lang=pug"
import script from "./view-dispute.vue?vue&type=script&lang=js"
export * from "./view-dispute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports